module.exports = __webpack_public_path__ + "static/media/cialfo-vertical_blue@4x.cdbaf041.png";